import React from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AuthProvider, useAuth } from './auth';
import { Layout } from './components/Layout';
import { Loading } from './components/ui';
import { Login } from './pages/Login';
import { DashboardPage } from './pages/Dashboard';
import { ProtokollePage } from './pages/Protokolle';
import { ProtokollDetailPage } from './pages/ProtokollDetail';
import { FahrzeugDetailPage, FahrzeugePage } from './pages/Fahrzeuge';
import { PoolPage } from './pages/Pool';
import { BenutzerPage, PersonenPage, VerteilerPage } from './pages/Stammdaten';

const qc = new QueryClient({
  defaultOptions: { queries: { retry: 1, refetchOnWindowFocus: false, staleTime: 20_000 } },
});

const Shell: React.FC = () => {
  const { profile, loading } = useAuth();
  if (loading) return <Loading text="Sitzung wird geprüft …" />;
  if (!profile) return <Login />;

  return (
    <Routes>
      <Route element={<Layout />}>
        <Route index element={<DashboardPage />} />
        <Route path="protokolle" element={<ProtokollePage />} />
        <Route path="protokolle/:id" element={<ProtokollDetailPage />} />
        <Route path="fahrzeuge" element={<FahrzeugePage />} />
        <Route path="fahrzeuge/:id" element={<FahrzeugDetailPage />} />
        <Route path="pool" element={<PoolPage />} />
        <Route path="personen" element={<PersonenPage />} />
        <Route path="verteiler" element={<VerteilerPage />} />
        <Route path="benutzer" element={<BenutzerPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
};

export const App: React.FC = () => (
  <QueryClientProvider client={qc}>
    <BrowserRouter>
      <AuthProvider>
        <Shell />
      </AuthProvider>
    </BrowserRouter>
  </QueryClientProvider>
);
